<template>
  <div class="box">
    <div class="box-header">
      <div class="col-12 col-md-12 col-sm-12 col-xs-12" style="border-top: 1px dashed #d2d6de; border-bottom: 1px dashed #d2d6de; margin-top: 10px;">
        <div class="row">
          <div class="form-group col-6 col-md-1 div-form-filtro">
            <select v-model="filtro.uf" style="width: auto;" class="form-control form-filtro">
              <option value="" selected>UF</option>
              <option value="AC">AC</option>
              <option value="AL">AL</option>
              <option value="AM">AM</option>
              <option value="AP">AP</option>
              <option value="BA">BA</option>
              <option value="CE">CE</option>
              <option value="DF">DF</option>
              <option value="ES">ES</option>
              <option value="GO">GO</option>
              <option value="MA">MA</option>
              <option value="MG">MG</option>
              <option value="MS">MS</option>
              <option value="MT">MT</option>
              <option value="PA">PA</option>
              <option value="PB">PB</option>
              <option value="PE">PE</option>
              <option value="PI">PI</option>
              <option value="PR">PR</option>
              <option value="RJ">RJ</option>
              <option value="RN">RN</option>
              <option value="RO">RO</option>
              <option value="RR">RR</option>
              <option value="RS">RS</option>
              <option value="SC">SC</option>
              <option value="SE">SE</option>
              <option value="SP">SP</option>
              <option value="TO">TO</option>
            </select>
          </div>
          <div class="form-group col-6 col-md-2 div-form-filtro">
            <select v-model="filtro.idc_status" style="width: auto;" class="form-control form-filtro">
              <option value="" selected>Status</option>
              <option value="1">Sucesso</option>
              <option value="2">Erro</option>
            </select>
          </div>
          <div class="form-group col-6 col-md-2 div-form-filtro">
            <select v-model="filtro.idc_origem" style="width: auto;" class="form-control form-filtro">
              <option value="" selected>Origem</option>
              <option value="1">Automático</option>
              <option value="2">Manual</option>
            </select>
          </div>
          <div class="form-group col-6 col-md-4 div-form-filtro">
            <select v-model="filtro.cd_status_motorista" style="width: auto;" class="form-control form-filtro">
              <option value="" selected>Status Motorista</option>
              <option value="1">Ativo</option>
              <option value="2">Reprovado</option>
              <option value="3">Aguardando Validação</option>
              <option value="4">Agendamento Solicitado</option>
              <option value="5">Aguardando Agendamento</option>
              <option value="6">Aguardando Ponto de Apoio</option>
              <option value="7">Aguardando Equipamento</option>
              <option value="8">gendamento Realizado</option>
              <option value="9">Excluído</option>
              <option value="10">Outras Praças</option>
              <option value="11">Pendente</option>
              <option value="12">Furto, Roubo ou Avaria</option>
              <option value="13">Aguardando Pré-análise</option>
              <option value="14">Cadastro não Finalizado - Pré-aprovado</option>
            </select>
          </div>
          <div class="form-group col-6 col-md-4 div-form-filtro" style="display: flex;">
            <input v-model="filtro.dt_envio_ini" type="text" v-mask="'##/##/####'" class="form-control form-filtro" style="width: 90px;" placeholder="Dt. Envio" />
            &nbsp; até &nbsp;
            <input v-model="filtro.dt_envio_fim" type="text" v-mask="'##/##/####'" class="form-control form-filtro" style="width: 90px;" placeholder="Dt. Envio" />
          </div>
          <div class="form-group col-6 col-md-5 div-form-filtro">
            <Dropdown
              v-on:selected="motoristaFiltroSelection"
              v-on:filter="getMotoristas"
              :options="listMotorista"
              :maxItem="10"
              placeholder="Motorista">
            </Dropdown>
          </div>
          <div class="form-group col-6 col-md-3 div-form-filtro">
            <button type="button" class="btn btn-sm btn-success btn-novo" @click="filtrar()">Filtrar</button>
            &nbsp;
            <button type="button" class="btn btn-sm btn-warning btn-novo" @click="limparFiltro()">Limpar</button>
            &nbsp;
            <export-excel
              :fields = "listaExcelFields"
              :fetch = "gerarExcel"
              type = "xls"
              worksheet = "Mensagens"
              name = "historico-mensagens-enviadas.xls"
              class="btn btn-sm btn-primary btn-novo" style="width: 33px"
              data-tooltip="Exportar Excel"
            ><i class="fa fa-file-excel"></i></export-excel>
          </div>
        </div>
      </div>
    </div>
		<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>
		<div v-show="successMessage != ''" class="alert alert-success">{{ successMessage }}</div>

    <vuetable ref="vuetable"
      :api-url="urlApi"
      :http-options="httpOptions"
      :fields="fields"
      :sort-order="sortOrder"
      :css="css.table"
      pagination-path=""
      :per-page="perPage"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:loading="onLoading"
      @vuetable:loaded="onLoaded"
      no-data-template="Nenhum registro encontrado"
    >
      <template slot="idc_status" slot-scope="props">
        <span class="label" v-bind:class="{
            'label-success': props.rowData.idc_status === 1,
            'label-danger': props.rowData.idc_status !== 1
          }">{{ props.rowData.idc_status === 1 ? 'Sim' : 'Não' }}</span>
      </template>
      <template slot="idc_origem" slot-scope="props">
        <span class="label" v-bind:class="{
            'label-info': props.rowData.idc_origem === 1,
            'label-warning': props.rowData.idc_origem !== 1
          }">{{ props.rowData.origem_desc }}</span>
      </template>
    </vuetable>
    <div class="row vuetable-pagination ui basic segment grid" style="padding: 10px">
      <vuetable-pagination-info ref="paginationInfo"
        :css="css.pagination"
        info-template="Exibindo {from} - {to} de {total}"
        no-data-template="" />

      <vuetable-pagination ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
        style="margin: 0" />
    </div>
  </div>
</template>

<script>
import { Vuetable, VuetablePagination, VuetablePaginationInfo } from 'vuetable-2'
import VuetableCss from '../../helpers/VuetableCss'
import Dropdown from 'vue-simple-search-dropdown'
import moment from 'moment'

import ActionsLogin from '../../actions/LoginActions'
import MotoristaActions from '../../actions/MotoristaActions'
import MensagemHistoricoActions from '../../actions/MensagemHistoricoActions'

export default {
  name: 'historico',
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    Dropdown
  },
  data () {
    return {
      css: VuetableCss,
      filterText: '',
      perPage: 25,
      errorMessage: '',
      successMessage: '',
      urlApiDefault: process.env.URL_API_MENSAGEM + '/message-history',
      urlApi: process.env.URL_API_MENSAGEM + '/message-history',
      fields: [
        {
          name: 'nome_motorista',
          title: 'Motorista',
          sortField: 'motorista.nome'
        },
        {
          name: 'desc_status_motorista',
          title: 'Status Motorista',
          sortField: 'status_motorista.descricao'
        },
        {
          name: '__slot:idc_status',
          title: 'Sucesso',
          sortField: 'idc_status'
        },
        {
          name: '__slot:idc_origem',
          title: 'Origem',
          sortField: 'idc_origem'
        },
        {
          name: 'created_at',
          title: 'Data',
          sortField: 'created_at',
          callback: 'formataData'
        },
        {
          name: 'observacoes',
          title: 'Observações',
          sortField: 'observacoes'
        }
      ],
      sortOrder: [
        { field: 'created_at', direction: 'desc' }
      ],
      data: [],
      filtro: {
        uf: '',
        idc_status: '',
        idc_origem: '',
        cd_status_motorista: '',
        cd_motorista: '',
        dt_envio_ini: '',
        dt_envio_fim: ''
      },
      listMotorista: [],
      listaExcelFields: {
        'Motorista': 'nome_motorista',
        'Status Motorista': 'desc_status_motorista',
        'Status': 'status_desc',
        'Origem': 'origem_desc',
        'Data': 'created_at',
        'Observações': 'observacoes'
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Histórico'

    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
  },
  computed: {
    httpOptions () {
      return { headers: { 'Authorization': 'Bearer ' + ActionsLogin.getToken() } }
    }
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onLoading () {
      this.$parent.$parent.$data.showModalLoader = true
    },
    onLoaded () {
      this.$parent.$parent.$data.showModalLoader = false
    },
    filtrar () {
      if (
        this.filtro.uf ||
        this.filtro.cd_status_motorista ||
        this.filtro.cd_motorista ||
        this.filtro.dt_envio_ini ||
        this.filtro.dt_envio_fim ||
        this.filtro.idc_status ||
        this.filtro.idc_origem
      ) {
        let url = this.urlApiDefault

        if (this.filtro.uf) {
          url += `?end_uf=${this.filtro.uf}`
        }
        if (this.filtro.cd_status_motorista) {
          url += `${(url.indexOf('?') === -1 ? '?' : '&')}cd_status_motorista=${this.filtro.cd_status_motorista}`
        }
        if (this.filtro.cd_motorista) {
          url += `${(url.indexOf('?') === -1 ? '?' : '&')}cd_motorista=${this.filtro.cd_motorista}`
        }
        if (this.filtro.dt_envio_ini) {
          url += `${(url.indexOf('?') === -1 ? '?' : '&')}dt_envio_ini=${this.filtro.dt_envio_ini}`
        }
        if (this.filtro.dt_envio_fim) {
          url += `${(url.indexOf('?') === -1 ? '?' : '&')}dt_envio_fim=${this.filtro.dt_envio_fim}`
        }
        if (this.filtro.idc_status) {
          url += `${(url.indexOf('?') === -1 ? '?' : '&')}idc_status=${this.filtro.idc_status}`
        }
        if (this.filtro.idc_origem) {
          url += `${(url.indexOf('?') === -1 ? '?' : '&')}idc_origem=${this.filtro.idc_origem}`
        }

        this.urlApi = url
      }
    },
    limparFiltro () {
      this.filtro = {
        uf: '',
        idc_status: '',
        idc_origem: '',
        cd_status_motorista: '',
        cd_motorista: '',
        dt_envio_ini: '',
        dt_envio_fim: ''
      }

      this.urlApi = this.urlApiDefault
    },
    motoristaFiltroSelection (selection) {
      this.filtro.cd_motorista = selection.id
    },
    getMotoristas (keyword) {
      if (keyword.length > 2) {
        MotoristaActions.listarMotoristasComFiltroPorNome(keyword)
          .then(res => {
            this.listMotorista = []

            res.forEach(i => {
              this.listMotorista.push({ id: i.cd_motorista, name: i.nome.toUpperCase() })
            })
          })
      }
    },
    formataData (val) {
      let date = moment(val)
      if (date.isValid()) {
        return date.format('DD/MM/YYYY HH:mm:ss')
      }
      return ''
    },
    async gerarExcel () {
      let res = await MensagemHistoricoActions.listar(this.filtro)
      return res
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/mensagens/Historico.vue